// removed by extract-text-webpack-plugin
module.exports = {"svg":"_2Vicq"};


//////////////////
// WEBPACK FOOTER
// ./common/components/Svg/svg.scss
// module id = 489
// module chunks = 0 1